import { Col, Divider, Row, Typography, } from "antd";
import { Link, useParams, useSearchParams } from "react-router-dom";
import TermsCard from "./partials/terms-card";
import UberLogo from '../../assets/imgs/sponsor-logo-uber.png';
import ThrivveLogo from '../../assets/imgs/thrivve-logo-ar.svg';
import secBgA from '../../assets/imgs/section-bg-6.svg';
import secBgB from '../../assets/imgs/section-bg-7.svg';
import linedThrivveLogo from '../../assets/imgs/thrivveLinedLogo.png';
// import CarImg from '../../assets/imgs/car-honda.png';
import ManAndCar from '../../assets/imgs/new-car-img.png';
// import Man from '../../assets/imgs/man.png';
import "./terms-and-conditions.style.css"
import { useMemo } from "react";

function TermsAndConditions() {
    const { customerId } = useParams();
    const [searchParams] = useSearchParams();
    const registerUrl = useMemo(() => {
        let completeParams = searchParams;
        let baseURL = "https://thrivve.go.link/uber";
        const testBaseURL = "https://thrivvetest.go.link/uber";
        completeParams.append("adj_t", "1tjj92kg")
        if (customerId) {
            completeParams.append("cid", customerId);
        }
        const hostName = window.location.hostname;
        if (hostName.includes("staging") || hostName.includes("dev")) {
            baseURL = testBaseURL;
        }
        const stringfiedParams = completeParams.toString();
        return `${baseURL}?${stringfiedParams}`;

    }, [customerId, searchParams]);
    const terms = [
        "دخل يصل ل11 الف ريال.",
        "تفعيل حسابك في أوبر.",
        "سيارة بأقساط ميسرة يمكنك تسدسدها من خلال عملك مع أوبر.",
        "بدون كفيل وبدفعة أولى مقداها 1000 ريال فقط.",
        "ميزة سحب دخلك من أوبر يومياََ ودون حاجة الانتظار لنهاية الأسبوع.",
        "تأمين شامل على السيارة.",
        "صيانة دورية مجانية.",
        "دعم خاص أثناء الرحلات ومساعدة على الطريق.",
        "حوافز ومكافآت و مسابقات حسب أداء الكباتن يتم الإعلان عنها شهريا."
    ];
    const conditions = [
        "سعودي/ـة او ابن مواطنة وعمرك بين 21 و 50 سنة.",
        "لديك رخصة قبادة سارية لا يقل عن سنة.",
        "لا يوجد تعثرات سابقة في سجلك الائتماني (سمة)."
    ];
    return (
        <Row justify={"center"} align={"top"} className="terms-and-conditions-outer-row" >
            <Col>
                <Row className="terms-and-conditions" align={'top'}>
                    <Col className="hero-section" span={24}>
                        <Row>
                            <Col xl={12} lg={12} md={24} sm={24} xs={24}>
                                <Row>
                                    <Col span={24} className="title-col">
                                        <Typography.Text className="title">
                                            عرض خاص للعمل مع أوبر
                                        </Typography.Text>
                                    </Col>
                                    <Col span={24} className="subtitle-col">
                                        <Typography.Text className="subtitle">
                                            لأول مرة في المملكة ثرايف تقدم بالشراكة الحصرية مع أوبر
                                        </Typography.Text>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xl={12} lg={12} md={0} sm={0} xs={0}></Col>
                        </Row>
                        <img className="lined-logo" src={linedThrivveLogo} alt={" "} />
                        <img className="man-and-car-hero-img" src={ManAndCar} alt=" " loading="lazy" />
                        {/* <img className="man" src={Man} alt=" " loading="lazy" /> */}
                    </Col>
                    <Col span={24}>
                        <Row className="logo-section" justify={"center"} align={"middle"} gutter={8}>
                            <Col className="logo-col">
                                <img src={ThrivveLogo} className="logo-img" loading="lazy" alt={"Thrivve-logo"} />
                            </Col>
                            <Col className="logo-col">
                                <Divider className="logo-divider" type="vertical" />
                            </Col>
                            <Col className="logo-col hero-uber-logo">
                                <img src={UberLogo} className="logo-img" loading="lazy" alt="uber-logo" />
                            </Col>
                            <img className="logo-sect-bg-a" src={secBgA} alt="sect-bg-a" loading="lazy" />
                            <img className="logo-sect-bg-b" src={secBgB} alt="sect-bg-a" loading="lazy" />
                        </Row>
                    </Col>
                    <Col span={24} className="main-section-col">
                        <Row
                            justify={"center"} align={"top"}
                            gutter={[{ xl: 32, lg: 0, md: 0, sm: 0, xs: 0 }, 56]}
                        >
                            <Col xl={12} lg={24} md={24} sm={24} xs={24}>
                                <TermsCard items={terms} />
                            </Col>
                            <Col xl={12} lg={24} md={24} sm={24} xs={24}>
                                <TermsCard title="الشروط والأحكام" items={conditions} />
                            </Col>
                        </Row>
                    </Col>
                    <Col className="reg-btn-section" span={24}>
                        <Row>
                            <Link className={"button"} to={registerUrl}>
                                حمل التطبيق الأن
                            </Link>
                        </Row>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
}
export default TermsAndConditions;